import { render, staticRenderFns } from "./orderDespatchTaskList.vue?vue&type=template&id=9d27fcd8&"
import script from "./orderDespatchTaskList.vue?vue&type=script&lang=js&"
export * from "./orderDespatchTaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports